import React, { PropTypes, Component } from 'react';
import classnames from 'classnames';
import Icon from 'common/components/svg_icon';

// fetch notification constant set for 5 minutes
const FETCH_INTERVAL = 1000 * 60 * 5;
// const FETCH_INTERVAL = 1000 * 30;

export default class Notifications extends Component {
  constructor(props) {
    super(props);
    this.fetch = this.fetch.bind(this);
  }

  componentDidMount() {
    const { shouldShow, userId } = this.props;
    this.timeout = shouldShow && userId ? setInterval(this.fetch, FETCH_INTERVAL) : null;
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  fetch() {
    const { fetchNotifications, userId } = this.props;
    fetchNotifications(userId);
  }

  render() {
    const { unseen, toggleDrawer, shouldShow } = this.props;

    if (!shouldShow) {
      return null;
    }

    const iconClasses = classnames('svg-icon svg-icon-md', { inactive: !unseen });
    return (<div className="hide-for-small-only notifications ">
      <button
        type="button"
        onClick={toggleDrawer}
        className="btn btn-icon-only btn-notifications"
      >
        <Icon className={iconClasses} icon="notifications" />
      </button>
      {unseen > 0 ? <span className="badge badge-primary badge-sm">{ unseen }</span> : ''}
    </div>);
  }
}

Notifications.propTypes = {
  unseen: PropTypes.number,
  shouldShow: PropTypes.bool,
  toggleDrawer: PropTypes.func.isRequired,
  fetchNotifications: PropTypes.func.isRequired,
  userId: PropTypes.number,
};



// WEBPACK FOOTER //
// ./header/components/notifications.jsx